export default __webpack_public_path__ + "static/media/ars-maquette-medium-webfont.e98e1952.woff2";